module.exports = __webpack_public_path__ + "img/direction_filter_icon.f4b7aa98.svg";